var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "admin-table" },
    [
      _c(
        "ma-modal",
        { ref: "adminGagEditModal", attrs: { type: "small" } },
        [
          _c("template", { slot: "modalContent" }, [
            _c("div", { staticClass: "modal__main" }, [
              _c("p", { staticClass: "headline-large mg mg--b-1 black" }, [
                _vm._v(_vm._s(_vm.$t("gagRepMat.title")))
              ]),
              _c(
                "div",
                { staticClass: "grid mg mg--t-4" },
                [
                  _c("ma-input-text", {
                    attrs: {
                      type: "text",
                      name: "rep_type_code",
                      col: 2,
                      icon: "house",
                      literal: "gagRepMat.table.rep_type_code",
                      disabled: "",
                      value: _vm.repMat.rep_type_code
                    }
                  }),
                  _c("ma-input-select", {
                    attrs: {
                      type: "select",
                      name: "rep_type",
                      col: 2,
                      icon: "house",
                      literal: "reparations.table.type",
                      options: _vm.adminRepTypes.results,
                      value: _vm.repMat.rep_type
                    },
                    on: {
                      change: function($event) {
                        _vm.repMat.rep_type = $event
                      }
                    }
                  }),
                  _c("ma-input-select", {
                    attrs: {
                      type: "select",
                      name: "dam_measure_unit",
                      col: 2,
                      icon: "house",
                      literal: "gagRepMat.table.dam_measure_unit",
                      options: _vm.adminDamagesSurfaceUnits,
                      value: _vm.repMat.dam_measure_unit
                    },
                    on: {
                      change: function($event) {
                        _vm.repMat.dam_measure_unit = $event
                      }
                    }
                  })
                ],
                1
              )
            ]),
            _c("div", { staticClass: "modal--actions mg mg--t-5" }, [
              _c(
                "button",
                {
                  staticClass: "mainBlue mg mg--r-2",
                  on: { click: _vm.handleSave }
                },
                [_vm._v(_vm._s(_vm.$t("actions.save")))]
              ),
              _c(
                "button",
                {
                  staticClass: "secondaryBlue",
                  on: { click: _vm.handleCancel }
                },
                [_vm._v(_vm._s(_vm.$t("actions.cancel")))]
              )
            ])
          ])
        ],
        2
      ),
      _c("p", { staticClass: "mg mg--b-4 mg--t-4 headline-large" }, [
        _vm._v(_vm._s(_vm.$t("gagRepMat.title")))
      ]),
      _c("table", { staticClass: "table" }, [
        _c("thead", [
          _c(
            "tr",
            { staticClass: "bg-blueDark" },
            [
              _c("th", { staticClass: "border-right" }, [
                _c("p", { staticClass: "text-medium white" }, [
                  _vm._v(_vm._s(_vm.$t("gagRepMat.table.rep_type_code")))
                ])
              ]),
              _c("th", { staticClass: "border-right" }, [
                _c("p", { staticClass: "text-medium white" }, [
                  _vm._v(_vm._s(_vm.$t("gagRepMat.table.rep_description")))
                ])
              ]),
              _c("th", { staticClass: "border-right" }, [
                _c("p", { staticClass: "text-medium white" }, [
                  _vm._v(_vm._s(_vm.$t("gagRepMat.table.rep_mat")))
                ])
              ]),
              _c("th", { staticClass: "border-right" }, [
                _c("p", { staticClass: "text-medium white" }, [
                  _vm._v(_vm._s(_vm.$t("gagRepMat.table.mat_format_sale")))
                ])
              ]),
              _c("th", { staticClass: "border-right" }, [
                _c("p", { staticClass: "text-medium white" }, [
                  _vm._v(_vm._s(_vm.$t("gagRepMat.table.dam_measure_unit")))
                ])
              ]),
              _c("th", { staticClass: "border-right" }, [
                _c("p", { staticClass: "text-medium white" }, [
                  _vm._v(
                    _vm._s(_vm.$t("gagRepMat.table.conv_unit_per_mat_measure"))
                  )
                ])
              ]),
              _c("th", { staticClass: "border-right" }, [
                _c("p", { staticClass: "text-medium white" }, [
                  _vm._v(_vm._s(_vm.$t("gagRepMat.table.mat_unit_price")))
                ])
              ]),
              _c("th", { staticClass: "border-right" }, [
                _c("p", { staticClass: "text-medium white" }, [
                  _vm._v(_vm._s(_vm.$t("gagRepMat.table.is_hours")))
                ])
              ]),
              _c("th", { staticClass: "no--border" }, [
                _c("p", { staticClass: "text-medium white" }, [
                  _vm._v(_vm._s(_vm.$t("gagRepMat.table.image")))
                ])
              ]),
              _vm.stateUserIsSuperAdmin
                ? [
                    _c("th", {
                      staticClass: "border-right",
                      attrs: { width: "50px" }
                    })
                  ]
                : _vm._e()
            ],
            2
          )
        ]),
        _vm.hasData
          ? _c(
              "tbody",
              _vm._l(_vm.table, function(row) {
                return _vm.table
                  ? _c(
                      "tr",
                      [
                        _c("td", [
                          _c("p", { staticClass: "text-medium black" }, [
                            _vm._v(_vm._s(row.rep_type_code))
                          ])
                        ]),
                        _c("td", { staticClass: "border-right" }, [
                          _c("p", { staticClass: "text-medium black" }, [
                            _vm._v(_vm._s(row.rep_description))
                          ])
                        ]),
                        _c("td", { staticClass: "border-right" }, [
                          _c("p", { staticClass: "text-medium black" }, [
                            _vm._v(_vm._s(row.rep_mat))
                          ])
                        ]),
                        _c("td", { staticClass: "border-right" }, [
                          _c("p", { staticClass: "text-medium black" }, [
                            _vm._v(_vm._s(row.mat_format_sale))
                          ])
                        ]),
                        _c("td", { staticClass: "border-right" }, [
                          _c("p", { staticClass: "text-medium black" }, [
                            _vm._v(_vm._s(row.dam_measure_unit))
                          ])
                        ]),
                        _c("td", { staticClass: "border-right" }, [
                          _c("p", { staticClass: "text-medium black" }, [
                            _vm._v(_vm._s(row.conv_unit_per_mat_measure))
                          ])
                        ]),
                        _c("td", { staticClass: "border-right" }, [
                          _c("p", { staticClass: "text-medium black" }, [
                            _vm._v(_vm._s(row.mat_unit_price))
                          ])
                        ]),
                        _c("td", { staticClass: "border-right" }, [
                          _c("p", { staticClass: "text-medium black" }, [
                            _vm._v(_vm._s(row.is_hours))
                          ])
                        ]),
                        _c("td", { staticClass: "no--border" }, [
                          _c("p", { staticClass: "text-medium black" }, [
                            _vm._v(_vm._s(row.image))
                          ])
                        ]),
                        _vm.stateUserIsSuperAdmin
                          ? [
                              _c("td", { staticClass: "text-align--right" }, [
                                _c(
                                  "div",
                                  { staticClass: "grid grid--jc-bottom" },
                                  [
                                    _c("svgicon", {
                                      staticClass: "svg-icon-action",
                                      attrs: {
                                        name: "edit",
                                        height: "16",
                                        widht: "16"
                                      },
                                      on: {
                                        click: function($event) {
                                          return _vm.handleEdit(row)
                                        }
                                      }
                                    }),
                                    _c("svgicon", {
                                      staticClass: "svg-icon-action mg mg--l-2",
                                      attrs: {
                                        name: "trash",
                                        height: "16",
                                        widht: "16"
                                      },
                                      on: {
                                        click: function($event) {
                                          return _vm.handleDelete(row)
                                        }
                                      }
                                    })
                                  ],
                                  1
                                )
                              ])
                            ]
                          : _vm._e()
                      ],
                      2
                    )
                  : _vm._e()
              }),
              0
            )
          : _vm._e()
      ]),
      _vm.hasData
        ? _c(
            "div",
            { staticClass: "grid grid--jc-bottom mg mg--t-4" },
            [
              _c("ma-paginator", {
                staticClass: "mg mg--t-2 mg--b-4",
                attrs: { current: _vm.currentPage, total: _vm.totalPages },
                on: {
                  "page:update": _vm.handlePageUpdate,
                  "page:set": _vm.handlePageSet
                }
              })
            ],
            1
          )
        : _vm._e(),
      !_vm.hasData
        ? _c("ma-empty", {
            attrs: {
              icon: "recherche",
              title: _vm.$t("common.noresults.short"),
              descr: _vm.$t("common.noresults.long")
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }